(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sale-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        clearTimeout(t);
        var args = arguments;
        t = setTimeout(function () { fn.apply(null, args); }, wait);
      };
    }

    function setStripHeightVar(height) {
      document.documentElement.style.setProperty('--sale-timer-strip-height', height + 'px');
      document.dispatchEvent(
        new CustomEvent('sale-timer-strip:visibility', {
          detail: { visible: height > 0, height: height },
        })
      );
    }

    function trackElementHeight(selector, cssVarName) {
      var el = document.querySelector(selector);
      if (!el) {
        document.documentElement.style.setProperty(cssVarName, '0px');
        return;
      }

      function setVar(height) {
        document.documentElement.style.setProperty(cssVarName, height + 'px');
      }

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            setVar(entries[i].contentRect.height);
          }
        });
        ro.observe(el);
      } else {
        setVar(el.getBoundingClientRect().height);
        window.addEventListener(
          'resize',
          debounce(function () {
            setVar(el.getBoundingClientRect().height);
          }, 150),
          { passive: true }
        );
      }
    }

    function setupOffsetTracking() {
      trackElementHeight('.shopify-section--header', '--header-height');
      trackElementHeight('.shopify-section--app-download-bar', '--app-download-bar-height');
    }

    function initSaleTimerStrip(root) {
      var endAttr = root.getAttribute('data-end-time');
      if (!endAttr) return;

      var endTime = new Date(endAttr).getTime();
      if (isNaN(endTime)) return;

      var startAttr = root.getAttribute('data-start-time');
      var startTime = null;
      if (startAttr) {
        var parsedStart = new Date(startAttr).getTime();
        if (!isNaN(parsedStart)) startTime = parsedStart;
      }

      var stickyMode = root.getAttribute('data-sticky-mode'); // 'dismissible' | 'sticky'
      var storageKey = root.getAttribute('data-storage-key');
      var closeBtn = root.querySelector('[data-sale-timer-close]');
      var hh = root.querySelector('[data-sts-hh]');
      var mm = root.querySelector('[data-sts-mm]');
      var ss = root.querySelector('[data-sts-ss]');

      var dismissed =
        stickyMode === 'dismissible' && sessionStorage.getItem(storageKey) === '1';

      var intervalId = null;
      var isCurrentlyVisible = false;

      function reportHeight() {
        if (root.classList.contains('is-visible')) {
          setStripHeightVar(root.getBoundingClientRect().height);
        } else {
          setStripHeightVar(0);
        }
      }

      function tick() {
        var now = Date.now();
        var started = !startTime || now >= startTime;
        var ended = now >= endTime;
        var shouldShow = started && !ended && !dismissed;

        if (shouldShow !== isCurrentlyVisible) {
          isCurrentlyVisible = shouldShow;
          root.hidden = !shouldShow;
          root.classList.toggle('is-visible', shouldShow);
          reportHeight();
        }

        if (ended) {
          if (intervalId) clearInterval(intervalId);
          return;
        }

        if (!shouldShow) return;

        var diff = endTime - now;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);

        if (hh) hh.textContent = pad(h);
        if (mm) mm.textContent = pad(m);
        if (ss) ss.textContent = pad(s);
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dismissed = true;
          sessionStorage.setItem(storageKey, '1');
          isCurrentlyVisible = false;
          root.classList.remove('is-visible');
          reportHeight();
        });
      }

      function setupMobileHeroReveal() {
        var hero = document.querySelector(
          '[data-hero-banner], .hero-banner, .slideshow-section, .image-banner, .collection-banner'
        );

        if (!hero || window.matchMedia('(min-width: 750px)').matches) {
          root.classList.add('is-sticky');
          return;
        }

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              // entry.isIntersecting is true while the hero is still on
              // screen — add is-sticky once it scrolls out of view, remove it if scrolled
              // back up so the hero is visible again.
              root.classList.toggle('is-sticky', !entry.isIntersecting);
            });
          },
          { threshold: 0 }
        );
        observer.observe(hero);
      }

      setupMobileHeroReveal();
      tick();
      intervalId = setInterval(tick, 1000);

      window.addEventListener('resize', debounce(reportHeight, 150), { passive: true });
    }

    var strips = document.querySelectorAll('[data-sale-timer-strip]');
    if (strips.length) {
      setupOffsetTracking();
      strips.forEach(initSaleTimerStrip);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
